import { Component, computed, inject } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { AuthService } from '@app/core/services/auth.service';
import { RoleService } from '../../../services/roles.service';
import { UserService } from '../../../services/user.service';

@Component({
  selector: 'app-user-menu',
  imports: [MatIconModule, MatMenuModule],
  templateUrl: './user-menu.component.html',
  styleUrl: './user-menu.component.scss',
})
export class UserMenuComponent {
  private readonly auth = inject(AuthService);
  private readonly roles = inject(RoleService);
  private readonly user = inject(UserService);
  private readonly actor = computed(() => this.roles.accessProfile()?.actor ?? null);

  protected readonly displayName = computed(() => this.firstNonBlank(
    this.actor()?.displayName, this.actor()?.email, this.actor()?.username,
    this.user.userFriendlyName(), 'Account',
  ));
  protected readonly secondaryLabel = computed(() => {
    const name = this.displayName().toLowerCase();
    return [this.actor()?.email, this.actor()?.username]
      .map(value => value?.trim() ?? '')
      .find(value => value.length > 0 && value.toLowerCase() !== name) ?? '';
  });
  protected readonly initials = computed(() => {
    const parts = this.displayName().split(/\s+/);
    return `${parts[0].charAt(0)}${parts.length > 1 ? parts[parts.length - 1].charAt(0) : parts[0].charAt(1)}`.toUpperCase();
  });

  async logout(): Promise<void> {
    await this.auth.logout();
  }

  private firstNonBlank(...values: Array<string | null | undefined>): string {
    return values.map(value => value?.trim() ?? '').find(value => value.length > 0) ?? '';
  }
}
